import axios from 'axios';

const api = axios.create({
  // baseURL: 'http://localhost:8000/api',
  // baseURL development: 'http://51.20.95.68:8000/api', http://13.48.230.190:8000/api
  // baseURL production: 'http://13.48.165.44:8000/api',
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api',
  // baseURL: '/api',

  headers: {
    'Content-Type': 'application/json',
  },
});

// הוספת Interceptor להזרקה אוטומטית של הטוקן לכל הבקשות
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// הוספת Interceptor לתגובות - טיפול בטוקן שפג תוקפו
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // אם קיבלנו 401 מהשרת, זה אומר שהטוקן לא תקף יותר
      localStorage.removeItem('authToken');
      localStorage.removeItem('rememberMe');
      
      // אם אנחנו לא בדף הלוגין, נשלח את המשתמש לשם
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
